module.exports = __webpack_public_path__ + "static/Everee-949cdc8b22e539f66da90b517c071d66.jpg";